<tt-tabs *ngIf="!!get" ttRememberId="w_purchhead.gb_main" [(ttSelectedId)]="get.gb_main" (ttSelectedIdChange)="onTabChanged()">
    <tt-tab ttId="PURCHLINES" ttLabel="purchhead_gb_main_purchlines" ttIcon="far fa-align-justify"></tt-tab>
    <tt-tab ttId="PURCHHEAD" ttLabel="purchhead_gb_main_purchhead" ttIcon="far fa-info-circle"></tt-tab>
    <tt-tab ttId="DOCUMENTS" ttLabel="purchhead_documents" ttIcon="far fa-file-alt"></tt-tab>
    <tt-tab ttId="MAILS" ttLabel="purchhead_gb_main_mails" ttIcon="far fa-envelope"></tt-tab>
    <tt-tab ttId="FUNCTIONS" ttLabel="purchhead_functions" ttIcon="far fa-ellipsis-h"></tt-tab>
</tt-tabs>
<tt-purch-head-purch-lines *ngIf="purchLinesGridReady" [hidden]="get?.gb_main !== 'PURCHLINES'" (gridReady)="gridPurchLines = $event; cdr.markForCheck()"></tt-purch-head-purch-lines>
<tt-purch-head-head [hidden]="get?.gb_main !== 'PURCHHEAD'" (linesChanged)="gridPurchLines?.gridfunc?.read()"></tt-purch-head-head>
<tt-documents-grid
    *ngIf="!!get && documentsGridReady"
    [hidden]="get.gb_main !== 'DOCUMENTS'"
    rememberId="w_purchhead.documents_grid"
    [params]="{
                    argtype: 'purch_internal_no',
                    argvalue: get.purch_internal_no,
                    searchtext: '',
                    doctype: 'd',
                    onlyFilenames: '0',
                }"
></tt-documents-grid>
<tt-email-grid
    *ngIf="!!get && emailGridReady"
    [hidden]="get.gb_main !== 'MAILS'"
    ttRememberId="w_purchhead_email_grid"
    argType="purch_internal_no"
    [argValue]="get.purch_internal_no"
    webpage="purchhead"
></tt-email-grid>
<tt-purch-head-functions [hidden]="get?.gb_main !== 'FUNCTIONS'" (onDelete)="submit.emit('delete')"></tt-purch-head-functions>
